import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import services from "../services";

export default function CancelBookingModal({ show, onHide, booking, type }) {
    const navigate = useNavigate()
    const [bookingCancellationReason, setBookingCancellationReason] = useState("");
    const handleCancelBooking = async () => {
        if (!booking) {
            console.error("No booking data available.");
            return;
        }

        let productType = null;
        let productCategory = null;

        if (["Trip", "TripBoard"].includes(type)) {
            productCategory = "updateByTripId";
        }

        else {
            const bookingProduct = [
                { key: 'flightId', category: 'update/flight' },
                { key: 'accomodationId', category: 'update/accommodation' },
                { key: 'ferryId', category: 'update/ferry' },
                { key: 'transferId', category: 'update/transfer' },
                { key: 'productId', category: 'update/product' }
            ];

            for (const item of bookingProduct) {
                if (booking?.[item.key]) {
                    productType = booking[item.key];
                    productCategory = item.category;
                    break;
                }
            }
        }
        if (!productCategory) {
            console.error("No valid product type/category found for the booking.");
            return;
        }

        try {
            const payload = {
                bookingStatus: "cancelled",
                cancellationReason: bookingCancellationReason
            };
            const response = await services.task.UPDATE_CANCEL_BOOKING_BY_ID(
                booking?.tripId,
                payload,
                productCategory
            );

            if (response?.status === 200) {
                toast?.success(response?.data?.message);
                onHide();
                // navigate(
                //     type === "Trip"
                //         ? "/trip"
                //         : type === "TripBoard"
                //             ? `/tripboard/${booking?.id}`
                //             : "/dailyDeparturesβ"
                // );


            }
        } catch (error) {
            toast.error('No Booking found')
            console.error(error);
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Cancel Booking</Modal.Title>
            </Modal.Header>

            <Modal.Body >
                <div >
                    <p>Are you sure you want to cancel this booking? Please tell us why</p>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter reason..."
                        value={bookingCancellationReason}
                        onChange={(e) => setBookingCancellationReason(e.target.value)}
                        className="border-b-0"
                    />


                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleCancelBooking}
                    disabled={!bookingCancellationReason}
                >
                    Yes, cancel booking
                </button>
            </Modal.Footer>


        </Modal>
    );
}
